// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"18357": "70fb16f8c80d","35560": "dc1982780893","36421": "81ab8361eabd","39054": "c258be7e8714","54226": "176c2cb0b509","66863": "c939bdd77392","78990": "aa917893b43d","95049": "72f91ee036c0",}[chunkId] + ".css"
}